const normalizeText = (value = '') => String(value || '').trim();

const toIsoStringOrNull = (value = null) => {
  if (!value) return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value.toISOString();
  }

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date.toISOString();
};

export const getProviderReviewOriginEntryId = (source = {}) => normalizeText(
  source.originEntryId
  || source.visitId
  || source.originVisitId
  || source.entryId
  || source.timelineEntryId
  || source.id
);

export const getProviderReviewOriginDate = (source = {}) => toIsoStringOrNull(
  source.originDate
  || source.visitDate
  || source.selectedDate
  || source.date
  || source.sourceDate
  || source.timestamp
  || source.createdAt
  || source.metadata?.selectedDate
  || source.metadata?.sourceDate
);

export const getProviderReviewOriginSourceId = (source = {}) => normalizeText(
  source.originSourceId
  || source.visitId
  || source.originVisitId
  || source.sourceId
  || source.sourceNoteId
  || source.id
);

export const buildProviderReviewNavigationState = ({
  childId = '',
  returnTo = '/dashboard',
  originEntryId = '',
  originDate = null,
  originSourceId = '',
  visitId = '',
  providerName = '',
  providerSpecialty = '',
  organizationName = '',
  doctorVisit = null,
} = {}) => ({
  childId: normalizeText(childId),
  returnTo: normalizeText(returnTo) || '/dashboard',
  originEntryId: normalizeText(originEntryId),
  originDate: toIsoStringOrNull(originDate),
  originSourceId: normalizeText(originSourceId),
  visitId: normalizeText(visitId),
  providerReview: {
    providerName: normalizeText(providerName),
    providerSpecialty: normalizeText(providerSpecialty),
    organizationName: normalizeText(organizationName),
    doctorVisit: doctorVisit || null,
  },
});

export const getProviderReviewNavigationContext = (state = {}) => {
  const context = buildProviderReviewNavigationState(state);
  const providerReview = state?.providerReview || context.providerReview || null;

  return {
    ...context,
    providerReview,
    hasOriginContext: Boolean(context.returnTo && (context.originEntryId || context.originDate || context.originSourceId || context.visitId)),
  };
};

export const buildProviderReviewReturnState = (context = {}) => {
  const normalized = getProviderReviewNavigationContext(context);
  return {
    childId: normalized.childId || null,
    timelineEntryId: normalized.originEntryId || normalized.visitId || null,
    selectedDate: normalized.originDate || null,
    originEntryId: normalized.originEntryId || null,
    originDate: normalized.originDate || null,
    originSourceId: normalized.originSourceId || normalized.visitId || null,
    visitId: normalized.visitId || null,
  };
};
